<template>
  <div class="item-standart" @click="itemClick">
    <div class="avatar">
      <child-avatar v-bind="avatarAttributes" />
    </div>

    <div class="content">
      <div class="description">
        {{ $t("feed.items.searchItemTerms", { terms: searchString }) }}
      </div>

      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'

  import searchEngineCodes from '@/constants/searchEngineCodes.js'
  import searchEnginePictures from '@/constants/searchEnginePictures.js'
  import analytics from '@/services/analytics.js'

  export default {
    extends: ItemBase,

    methods: {
      itemClick() {
        analytics.sendEvent('Pk_Search_Feed')
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      avatarAttributes() {
        let attributes = {
          child: this.child,
          size: 'small',
          showStatus: false
        }

        let engine = searchEngineCodes[this.item.details.engine]

        if (engine) {
          attributes['custom-icon-url'] = searchEnginePictures[engine]
        } else {
          attributes = {
            ...attributes,
            ...{
              'icon': 'IconMagnifier',
              'icon-color': '#878787',
              'icon-background-color': '#fff'
            }
          }
        }

        return attributes
      },

      searchString() {
        if (Array.isArray(this.item.details.search_terms)) {
          return this.item.details.search_terms.join(', ')
        } else {
          return this.item.details.search_term
        }
      }
    }
  }
</script>
